// Lib Imports
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, CheckBox, TextInput, Anchor, Button, Text } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

// CORE Imports
import PasswordInput from 'granite-admin/core/components/PasswordInput';
import FormField from 'granite-admin/core/components/FormField';
import PhoneInput from 'granite-admin/core/components/PhoneInput/v2';

// Application Imports
// import REGISTER_EVENTS from '../constants'

const RegisterForm = ({
  onSubmit,
  type,
  config
}) => {
  const [tocChecked, setTocChecked] = useState(false);
  const domainURL = process.env.REACT_APP_WEBSITE_URL;
  const {
    ProjectRegisterForm
  } = config?.registerDetails;
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    ...(type === 'phone' ? {
      phone: Yup.object().shape({
        number: Yup.string().required('Company Phone is required').min(6, 'Not valid').max(14, 'Not valid')
      })
    } : {
      email: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').email('Invalid email').required('Email is required')
    }),
    password: Yup.string().max(50, 'Too Long!').matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$/, 'Atleast 6 char, One capital, One number is required').required('Password is required'),
    confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must be same.').required('Confirm Password is required')
  });
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      first_name: '',
      last_name: '',
      ...(type === 'phone' ? {
        phone: {
          countryCode: 'in'
        }
      } : {
        email: ''
      }),
      password: '',
      confirm_password: ''
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  }) => ProjectRegisterForm ? /*#__PURE__*/React.createElement(ProjectRegisterForm, {
    onSubmit: onSubmit,
    type: type,
    validationSchema: validationSchema,
    setTocChecked: setTocChecked,
    tocChecked: tocChecked,
    domainURL: domainURL
  }) : /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, errors.title), /*#__PURE__*/React.createElement(Box, {
    direction: "row-responsive",
    gap: "large"
  }, /*#__PURE__*/React.createElement(FormField, {
    basis: "100%",
    name: "first_name",
    label: "First Name *",
    error: touched.first_name && errors.first_name
  }, /*#__PURE__*/React.createElement(TextInput, {
    name: "first_name",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.first_name
  })), /*#__PURE__*/React.createElement(FormField, {
    name: "last_name",
    basis: "100%",
    label: "Last Name *",
    error: touched.last_name && errors.last_name
  }, /*#__PURE__*/React.createElement(TextInput, {
    name: "last_name",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.last_name
  }))), type === 'phone' ? /*#__PURE__*/React.createElement(FormField, {
    name: "phone",
    label: "Phone Number *",
    error: touched.phone && errors.phone && errors.phone.number
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    inputProps: {
      name: 'phone'
    },
    value: values.phone,
    onChange: phone => {
      let ph = {
        ...phone,
        phone: `+${phone?.number}`
      };
      setFieldValue('phone', ph);
    },
    onBlur: handleBlur
  })) : /*#__PURE__*/React.createElement(FormField, {
    name: "email",
    label: "Email Address *",
    error: touched.email && errors.email
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "email",
    name: "email",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.email
  })), /*#__PURE__*/React.createElement(FormField, {
    name: "password",
    label: "Password",
    required: true,
    error: touched.password && errors.password
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    name: "password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.password,
    type: "password"
  })), /*#__PURE__*/React.createElement(FormField, {
    name: "confirm_password",
    label: "Confirm Password *",
    error: touched.confirm_password && errors.confirm_password
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    name: "confirm_password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.confirm_password,
    type: "password"
  })), /*#__PURE__*/React.createElement(Box, {
    margin: {
      vertical: 'medium'
    }
  }, /*#__PURE__*/React.createElement(CheckBox, {
    checked: tocChecked,
    onChange: e => setTocChecked(e.target.checked),
    label: /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, "Agree to", /*#__PURE__*/React.createElement(Link, {
      target: '_blank',
      to: "terms"
    }, /*#__PURE__*/React.createElement(Anchor, {
      as: "span",
      label: "terms and conditions"
    })))
  })), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "start",
    label: isSubmitting ? 'Signing up ...' : 'Sign up',
    disabled: isSubmitting || !tocChecked,
    primary: true,
    color: "secondary"
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "end",
    gap: "xsmall",
    margin: {
      vertical: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Already have an account?"), /*#__PURE__*/React.createElement(Link, {
    to: "/login",
    style: {
      lineHeight: '13px'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    label: "Sign in",
    size: "small"
  })))));
};
RegisterForm.propTypes = {
  config: PropTypes.object,
  onSubmit: PropTypes.func,
  type: PropTypes.string
};
export default RegisterForm;